import { render, staticRenderFns } from "./EditDialogDefaultMainContainer.vue?vue&type=template&id=0568cf28&scoped=true"
import script from "./EditDialogDefaultMainContainer.vue?vue&type=script&lang=js"
export * from "./EditDialogDefaultMainContainer.vue?vue&type=script&lang=js"
import style0 from "./EditDialogDefaultMainContainer.vue?vue&type=style&index=0&id=0568cf28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568cf28",
  null
  
)

export default component.exports